<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Ziele</h1>
                <p class="h2">...und wenn die Nutzenden das erste Ziel erreicht haben, dann lassen weitere nicht lange auf sich warten...</p>
            </div>
            <div class="right-wrapper">
                <h2>Warum wöchentliche Ziele?</h2>
                <p class="text">Um neue Gewohnheiten erfolgreich zu übernehmen, ist es wichtig, auf kleineren Erfolgen aufzubauen. Vitadios wöchentliche Zielstruktur beginnt mit erreichbaren Zielen, die den Weg für neue Gewohnheiten ebnen, die anfangs vielleicht unmöglich erschienen. Durch konsequente Bemühungen und den Fokus auf kontinuierliche Fortschritte legen wir den Grundstein für einen langfristigen Erfolg bei der Gewohnheitsbildung.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 20
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

